import React from 'react';

import { SkeletonBlock } from '../../../components/skeleton/skeleton';

export default function BankAccountsSkeleton() {
  return (
    <div className="space-y-8" aria-hidden="true">
      <section className="reveal overflow-hidden rounded-md border border-slate-200 bg-white p-5 shadow-sm dark:border-slate-700 dark:bg-slate-800">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
          <div className="space-y-2">
            <SkeletonBlock className="h-8 w-40 rounded-md" />
            <SkeletonBlock className="h-4 w-full max-w-md rounded" />
          </div>
          <SkeletonBlock className="h-10 w-full rounded-full sm:w-44" />
        </div>
        <div className="mt-6 space-y-4 border-t border-slate-100 pt-6 dark:border-slate-700">
          {[0, 1].map((k) => (
            <div
              key={k}
              className="flex flex-col gap-4 rounded-md border border-slate-100 p-4 sm:flex-row sm:items-center sm:justify-between dark:border-slate-700/80"
            >
              <div className="flex items-center gap-4">
                <SkeletonBlock className="h-12 w-16 rounded-md" />
                <SkeletonBlock className="h-5 w-36 rounded" />
              </div>
              <div className="flex gap-2">
                <SkeletonBlock className="h-8 w-24 rounded-full" />
                <SkeletonBlock className="h-8 w-16 rounded-full" />
              </div>
            </div>
          ))}
        </div>
      </section>
      <section className="reveal overflow-hidden rounded-md border border-slate-200 bg-white p-5 shadow-sm dark:border-slate-700 dark:bg-slate-800">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
          <div className="space-y-2">
            <SkeletonBlock className="h-8 w-44 rounded-md" />
            <SkeletonBlock className="h-4 w-full max-w-md rounded" />
          </div>
          <SkeletonBlock className="h-10 w-full rounded-full sm:w-48" />
        </div>
        <div className="mt-6 space-y-4 border-t border-slate-100 pt-6 dark:border-slate-700">
          {[0, 1].map((k) => (
            <div
              key={k}
              className="rounded-md border border-slate-100 p-4 dark:border-slate-700/80"
            >
              <SkeletonBlock className="h-5 w-48 rounded" />
              <SkeletonBlock className="mt-2 h-4 w-32 rounded" />
              <SkeletonBlock className="mt-3 h-6 w-40 rounded" />
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
